import { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { MEDIA } from "@/data/content";

export default function Login() {
  const { user, login } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && user.email) return <Navigate to="/area-riservata" replace state={{ from: location }} />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) {
      setError(res.error || "Errore di accesso");
      toast.error("Accesso negato", { description: res.error });
    } else {
      toast.success("Benvenuto", { description: "Accesso effettuato con successo" });
    }
  };

  return (
    <div data-testid="page-login" className="min-h-screen pt-24 grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={MEDIA.arch} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1F2E]/55" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <span className="overline text-[#89E877]">Area Riservata</span>
          <div>
            <h2 className="font-display text-5xl leading-tight max-w-md">
              Il tuo dossier assicurativo,<br />sempre con te.
            </h2>
            <p className="mt-4 max-w-sm text-white/70">
              Polizze, scadenze, richieste e comunicazioni. Tutto in un'unica area riservata, accessibile 24/7.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 sm:p-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-8" data-testid="login-form">
          <div>
            <span className="overline">Accedi</span>
            <h1 className="mt-3 font-display text-5xl leading-tight">Bentornato.</h1>
            <p className="mt-3 text-muted-foreground">Inserisci le tue credenziali per accedere all'area riservata.</p>
          </div>

          <div>
            <label htmlFor="login-email" className="field-label">Email</label>
            <input
              id="login-email"
              type="email"
              autoComplete="email"
              required
              data-testid="login-input-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-input"
            />
          </div>

          <div>
            <label htmlFor="login-password" className="field-label">Password</label>
            <input
              id="login-password"
              type="password"
              autoComplete="current-password"
              required
              data-testid="login-input-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
            />
          </div>

          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}

          <button type="submit" disabled={loading} data-testid="login-submit" className="btn-primary w-full">
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>

          <p className="text-sm text-muted-foreground">
            Non hai ancora un account?{" "}
            <Link to="/registrati" className="underline-link text-foreground" data-testid="link-register">
              Registrati
            </Link>
          </p>

          <div className="border-t border-foreground/10 pt-6">
            <p className="text-xs uppercase tracking-[0.24em] text-muted-foreground mb-2">Demo</p>
            <p className="text-xs text-muted-foreground">
              cliente@xlbrokers.it · cliente2025
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
